import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const HashtagIcon = ({
  title = 'Hashtag',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  // This icon was initially imported with a fill color so to keep things compatable, we provide the color
  <CreateIconComponent viewBox="0 0 20 20" title={title} style={{ color: '#505050' }} {...props}>
    {/* prettier-ignore */}
    <g fillRule="evenodd" clipRule="evenodd"><path d="M14.81 1.405c.564.1.948.623.882 1.185l-.009.062-.532 3.014h2.384a1.076 1.076 0 01.063 2.15l-.063.003h-2.763l-.76 4.305h3.523a1.076 1.076 0 01.063 2.151l-.063.002h-3.902l-.567 3.216a1.076 1.076 0 01-2.129-.311l.01-.063.5-2.842H7.175l-.567 3.216a1.076 1.076 0 01-2.13-.311l.01-.063.5-2.842H2.466a1.076 1.076 0 01-.063-2.151l.063-.002h2.903l.76-4.306H2.465a1.076 1.076 0 01-.063-2.15l.063-.002h4.042l.598-3.387a1.076 1.076 0 012.129.31l-.01.063-.531 3.014h4.273l.597-3.387a1.076 1.076 0 011.247-.874zM12.586 7.82H8.314l-.76 4.305h4.273l.76-4.305z" /></g>
  </CreateIconComponent>
);

export default HashtagIcon;
